import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>ನಮ್ಮ ಬಗ್ಗೆ</h1>
          <p>1995 ರಿಂದ ಕೃಷಿ ವ್ಯಾಪಾರದಲ್ಲಿ ನಿಮ್ಮ ವಿಶ್ವಸನೀಯ ಪಾಲುದಾರ</p>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>ನಮ್ಮ ಕಥೆ</h2>
              <p>
                ಮುಕ್ತಂಕಾರ ಟ್ರೇಡರ್ಸ್, ಕೋಟ್ಯಾಳ್ – ಇದು ಕೇವಲ ಒಂದು ಕಂಪನಿಯ ಹೆಸರು ಅಲ್ಲ, ಇದು ನಮ್ಮ ಕುಟುಂಬದ, ನಮ್ಮ ಊರಿನ, ಮತ್ತು ಸಾವಿರಾರು ರೈತರ ವಿಶ್ವಾಸದ ಚಿಹ್ನೆ.
              </p>
              <p>
                ಇದು ಎಲ್ಲವೂ ಪ್ರಾರಂಭವಾಯಿತು ಕಳೆದ 80 ವರ್ಷಗಳ ಹಿಂದೆ, ನಮ್ಮ ಅಜ್ಜರು ಸರಳವಾಗಿ ತಮ್ಮ ಕೃಷಿ ಉತ್ಪನ್ನಗಳನ್ನು ಸಣ್ಣ ಮಟ್ಟದಲ್ಲಿ ಮಾರಾಟ ಮಾಡುವುದರಿಂದ. ಅವರು ತಮ್ಮ ಕಾಲದಲ್ಲಿ ಕೋಟ್ಯಾಳ್ ಹಳ್ಳಿಯಲ್ಲಿ ಒಂದು ಸಣ್ಣ ಅಗಡಿಯ ಮೂಲಕ ವ್ಯವಹಾರ ಪ್ರಾರಂಭಿಸಿದ್ದರು. ಅವರ ಶ್ರದ್ಧೆ, ಪರಿಷ್ರಮ ಮತ್ತು ನಿಷ್ಠೆಯಿಂದ, ಅದು ದಿನದಿಂದ ದಿನಕ್ಕೆ ಬೆಳೆಯತೊಡಗಿತು.
              </p>
              <p>
                ಇಂದು, ನಾವು ಅವರ ಅದೇ ತತ್ವಗಳನ್ನು ಅನುಸರಿಸುತ್ತಾ, ಈ ವೃತ್ತಿಯನ್ನು ಮುಂದುವರೆಸುತ್ತಿದ್ದೇವೆ. ನಾವು ಕೇವಲ ಒಂದು ವ್ಯಾಪಾರವನ್ನೇ ಮಾಡುವುದಿಲ್ಲ – ನಾವು ರೈತರೊಡನೆ ಸಂಬಂಧ ಕಟ್ಟಿಕೊಂಡು, ಅವರ ಉತ್ಪನ್ನಗಳಿಗೆ ನ್ಯಾಯವಾದ ಬೆಲೆ ಒದಗಿಸಲು ಶ್ರಮಿಸುತ್ತೇವೆ.
              </p>
              <p>
                ನಮ್ಮ ಪ್ರಯಾಣದಲ್ಲಿ, ನಾವು ಸ್ಥಳೀಯ ಮಟ್ಟದಿಂದ ಅಂತರರಾಷ್ಟ್ರೀಯ ಮಟ್ಟಕ್ಕೆ ವಿಸ್ತರಿಸಿದ್ದೇವೆ. ಇಂದು ನಮ್ಮ ಉತ್ಪನ್ನಗಳು ಭಾರತದಾದ್ಯಂತ ಮತ್ತು ವಿದೇಶಗಳಲ್ಲಿಯೂ ಸಹ ಪ್ರಸಿದ್ಧವಾಗಿವೆ. ನಾವು ಕೇವಲ ವ್ಯಾಪಾರಿಗಳಲ್ಲ, ನಾವು ರೈತರ ಮತ್ತು ಗ್ರಾಹಕರ ನಡುವಿನ ಸೇತುವೆಯಾಗಿದ್ದೇವೆ.
              </p>
              <p>
                ನಮ್ಮ ಯಶಸ್ಸಿನ ಹಿಂದಿನ ರಹಸ್ಯವೆಂದರೆ ಗುಣಮಟ್ಟಕ್ಕೆ ನಾವು ನೀಡುವ ಪ್ರಾಮುಖ್ಯತೆ ಮತ್ತು ಪ್ರತಿಯೊಬ್ಬ ರೈತರೊಂದಿಗೆ ನಾವು ಕಟ್ಟಿಕೊಂಡಿರುವ ವೈಯಕ್ತಿಕ ಸಂಬಂಧ. ನಾವು ಪ್ರತಿ ಋತುವಿನಲ್ಲಿ ರೈತರಿಗೆ ಸರಿಯಾದ ಮಾರ್ಗದರ್ಶನ, ತಾಂತ್ರಿಕ ಬೆಂಬಲ ಮತ್ತು ನ್ಯಾಯಯುತ ಬೆಲೆಯನ್ನು ಖಚಿತಪಡಿಸುತ್ತೇವೆ. ಇದರಿಂದಾಗಿ ನಾವು ಕೇವಲ ವ್ಯಾಪಾರ ಪಾಲುದಾರರಲ್ಲ, ಆದರೆ ಅವರ ಕುಟುಂಬದ ಒಂದು ಭಾಗವಾಗಿದ್ದೇವೆ.
              </p>
              <p>
                ಮುಂದಿನ ದಶಕಗಳಲ್ಲಿ, ನಾವು ಹೆಚ್ಚು ಹೆಚ್ಚು ರೈತರನ್ನು ತಲುಪಲು, ಹೊಸ ತಂತ್ರಜ್ಞಾನಗಳನ್ನು ಅಳವಡಿಸಿಕೊಳ್ಳಲು ಮತ್ತು ಕೃಷಿ ವ್ಯಾಪಾರದಲ್ಲಿ ಹೊಸ ಮಾನದಂಡಗಳನ್ನು ಸ್ಥಾಪಿಸಲು ಬದ್ಧರಾಗಿದ್ದೇವೆ. ನಮ್ಮ ಗುರಿ ಸರಳವಾಗಿದೆ – ಪ್ರತಿಯೊಬ್ಬ ರೈತರು ತಮ್ಮ ಶ್ರಮಕ್ಕೆ ಸರಿಯಾದ ಬೆಲೆಯನ್ನು ಪಡೆಯಬೇಕು ಮತ್ತು ಪ್ರತಿಯೊಬ್ಬ ಗ್ರಾಹಕರು ಉತ್ತಮ ಗುಣಮಟ್ಟದ ಉತ್ಪನ್ನಗಳನ್ನು ಪಡೆಯಬೇಕು.
              </p>
              <div className="story-highlights">
                <div className="highlight-item">
                  <i className="fas fa-globe"></i>
                  <span>ಜಾಗತಿಕ ವಿಸ್ತರಣೆ</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-handshake"></i>
                  <span>ವಿಶ್ವಸನೀಯ ಪಾಲುದಾರ</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-award"></i>
                  <span>ಗುಣಮಟ್ಟ ಖಾತರಿ</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2>ನಮ್ಮ ಮೂಲಭೂತ ಮೌಲ್ಯಗಳು</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <h3>ವಿಶ್ವಾಸ ಮತ್ತು ಸಮಗ್ರತೆ</h3>
              <p>ಪ್ರಾಮಾಣಿಕ ಮತ್ತು ಪಾರದರ್ಶಕ ವ್ಯವಹಾರಗಳ ಮೂಲಕ ದೀರ್ಘಕಾಲೀನ ಸಂಬಂಧಗಳನ್ನು ಕಟ್ಟಿಕೊಳ್ಳುವುದು</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>ರೈತರಿಗೆ ಮೊದಲ ಸ್ಥಾನ</h3>
              <p>ನಮ್ಮ ರೈತ ಸಮುದಾಯದ ಕಲ್ಯಾಣ ಮತ್ತು ಯಶಸ್ಸಿಗೆ ಯಾವಾಗಲೂ ಆದ್ಯತೆ ನೀಡುವುದು</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-globe"></i>
              </div>
              <h3>ಜಾಗತಿಕ ದೃಷ್ಟಿ</h3>
              <p>ಸ್ಥಳೀಯ ರೈತರನ್ನು ಅಂತರರಾಷ್ಟ್ರೀಯ ಮಾರುಕಟ್ಟೆಗಳು ಮತ್ತು ಅವಕಾಶಗಳೊಂದಿಗೆ ಸಂಪರ್ಕಿಸುವುದು</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <i className="fas fa-leaf"></i>
              </div>
              <h3>ಸುಸ್ಥಿರತೆ</h3>
              <p>ಸುಸ್ಥಿರ ಕೃಷಿ ಪದ್ಧತಿಗಳು ಮತ್ತು ಜವಾಬ್ದಾರಿಯುತ ವ್ಯಾಪಾರವನ್ನು ಉತ್ತೇಜಿಸುವುದು</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <h2>ನಮ್ಮ ನಾಯಕತ್ವ ತಂಡ</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-image">
                <img src="assets/images/team1.jpeg" alt="Akshay Bellagi" />
                <div className="member-social">
                  <a href="tel:7676831143" aria-label="Phone">
                    <i className="fas fa-phone"></i>
                  </a>
                  <a href="https://wa.me/917676831143" aria-label="WhatsApp">
                    <i className="fab fa-whatsapp"></i>
                  </a>
                </div>
              </div>
              <div className="member-info">
                <h3>ಅಕ್ಷಯ ಬೆಳ್ಳಗಿ</h3>
                <p>ಸಂಸ್ಥಾಪಕ ಮತ್ತು ಸಿಇಒ</p>
                <span className="member-bio">
                  ಕೃಷಿ ವ್ಯಾಪಾರದಲ್ಲಿ 25 ವರ್ಷಗಳ ಅನುಭವ ಹೊಂದಿರುವ ಅಕ್ಷಯ, ಮುಕ್ತಂಕಾರ ಟ್ರೇಡರ್ಸ್ ಅನ್ನು ಉದ್ಯಮದಲ್ಲಿ ವಿಶ್ವಸನೀಯ ಹೆಸರಾಗಿ ನಿರ್ಮಿಸುವಲ್ಲಿ ಪ್ರಮುಖ ಪಾತ್ರ ವಹಿಸಿದ್ದಾರೆ.
                </span>
              </div>
            </div>
            <div className="team-member">
              <div className="member-image">
                <img src="assets/images/team2.JPG" alt="Suresh Ramthirth" />
                <div className="member-social">
                  <a href="tel:9741672383" aria-label="Phone">
                    <i className="fas fa-phone"></i>
                  </a>
                  <a href="https://wa.me/919741672383" aria-label="WhatsApp">
                    <i className="fab fa-whatsapp"></i>
                  </a>
                </div>
              </div>
              <div className="member-info">
                <h3>ಸುರೇಶ ರಾಮತೀರ್ಥ</h3>
                <p>ಕಾರ್ಯಾಚರಣೆ ನಿರ್ದೇಶಕ</p>
                <span className="member-bio">
                  ಸುರೇಶ ನಮ್ಮ ಪಾಲುದಾರರಿಗೆ ಸುಗಮ ಸಾಗಾಣಿಕೆ ಮತ್ತು ಸಮರ್ಥ ವ್ಯಾಪಾರ ಪ್ರಕ್ರಿಯೆಗಳನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ಎಲ್ಲಾ ಕಾರ್ಯಾಚರಣಾ ಅಂಶಗಳನ್ನು ನಿರ್ವಹಿಸುತ್ತಾರೆ.
                </span>
              </div>
            </div>
            <div className="team-member">
              <div className="member-image">
                <img src="assets/images/team3.jpg" alt="Anil Bellagi" />
                <div className="member-social">
                  <a href="tel:7760246790" aria-label="Phone">
                    <i className="fas fa-phone"></i>
                  </a>
                  <a href="https://wa.me/917760246790" aria-label="WhatsApp">
                    <i className="fab fa-whatsapp"></i>
                  </a>
                </div>
              </div>
              <div className="member-info">
                <h3>ಅನಿಲ ಬೆಳ್ಳಗಿ</h3>
                <p>ಗುಣಮಟ್ಟ ಖಾತರಿ ಮುಖ್ಯಸ್ಥ</p>
                <span className="member-bio">
                  ಅನಿಲ ನಮ್ಮ ಗುಣಮಟ್ಟ ನಿಯಂತ್ರಣ ತಂಡವನ್ನು ನೇತೃತ್ವ ವಹಿಸುತ್ತಾರೆ, ಎಲ್ಲಾ ಉತ್ಪನ್ನಗಳು ಅಂತರರಾಷ್ಟ್ರೀಯ ಮಾನದಂಡಗಳು ಮತ್ತು ಗ್ರಾಹಕರ ನಿರೀಕ್ಷೆಗಳನ್ನು ಪೂರೈಸುವುದನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳುತ್ತಾರೆ.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="achievements-section">
        <div className="container">
          <h2>ನಮ್ಮ ಸಾಧನೆಗಳು</h2>
          <div className="achievements-grid">
            <div className="achievement-card">
              <i className="fas fa-trophy"></i>
              <h3>ಅತ್ಯುತ್ತಮ ವ್ಯಾಪಾರಿ ಪ್ರಶಸ್ತಿ</h3>
              <p>ಕರ್ನಾಟಕದಲ್ಲಿ ಅಗ್ರಗಣ್ಯ ಕೃಷಿ ವ್ಯಾಪಾರಿಯಾಗಿ ಗುರುತಿಸಲ್ಪಟ್ಟಿದ್ದೇವೆ</p>
            </div>
            <div className="achievement-card">
              <i className="fas fa-certificate"></i>
              <h3>ಐಎಸ್ಒ ಪ್ರಮಾಣೀಕೃತ</h3>
              <p>ವ್ಯಾಪಾರದಲ್ಲಿ ಅತ್ಯುನ್ನತ ಗುಣಮಟ್ಟದ ಮಾನದಂಡಗಳನ್ನು ಕಾಪಾಡಿಕೊಂಡಿದ್ದೇವೆ</p>
            </div>
            <div className="achievement-card">
              <i className="fas fa-star"></i>
              <h3>ವಿಶ್ವಸನೀಯ ಪಾಲುದಾರ</h3>
              <p>ರೈತರಿಂದ ಅತ್ಯಂತ ವಿಶ್ವಾಸಾರ್ಹ ವ್ಯಾಪಾರ ಪಾಲುದಾರರಾಗಿ ಆಯ್ಕೆಯಾಗಿದ್ದೇವೆ</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      
    </div>
  );
};

export default About; 
